/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';

const options = {
  I: 'I',
  II: 'II',
};

const MilitaryRegistrationCategoryDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={options} />;
};

export default MilitaryRegistrationCategoryDropdown;
